// 视频帧率
export const FRAMERATE = 20;
// 清晰度map
export const  CLARITYMAP = new Map([
  [0, '流畅'],
  [1, '标清'],
  [2, '高清'],
  [3, '超清'],
]);
